module.exports = __webpack_public_path__ + "img/PVP_CapTechMarketArmor1_ua.8e0129e5.webp";